export default (value: string | null) => {
  if (isNaN(Number(value)) || Number(value) < 1) {
    return "Value must be a positive number greater than zero"
  }
  return true
}
